import { useState } from 'react'
import { ScrollReveal } from '../../components'
import { FramePreview, ColorSwatches, FrameSelector } from '../../components/Configurator'
import { Button } from '../../components/Button'
import { useCartContext } from '../../context'
import { getProductById } from '../../data/products'
import styles from './ConfiguratorPage.module.css'

const coverNames: Record<string, string> = {
  red: 'Roja',
  yellow: 'Amarilla',
  green: 'Verde',
  blue: 'Azul',
}

export function ConfiguratorPage() {
  const [selectedFrame, setSelectedFrame] = useState<'black' | 'transparent'>('black')
  const [selectedCover, setSelectedCover] = useState('red')
  const { addItem, openCart } = useCartContext()

  const frameId = selectedFrame === 'black' ? 'frame-black-base' : 'frame-transparent-base'
  const coverId = `cover-${selectedCover}`
  const frame = getProductById(frameId)
  const cover = getProductById(coverId)
  const totalPrice = (frame?.price ?? 0) + (cover?.price ?? 0)

  const handleAddToCart = () => {
    if (frame) addItem(frame)
    if (cover) addItem(cover)
    openCart()
  }

  return (
    <div className={styles.page}>
      <ScrollReveal>
        <header className={styles.header}>
          <h1 className={styles.title}>Configura tus Gafas</h1>
          <p className={styles.subtitle}>
            Elige tu marco y cubierta para crear una combinación única.
          </p>
        </header>
      </ScrollReveal>

      <div className={styles.configurator}>
        <ScrollReveal direction="left">
          <FramePreview frame={selectedFrame} cover={selectedCover} />
        </ScrollReveal>

        <ScrollReveal direction="right">
          <div className={styles.controls}>
            <FrameSelector selected={selectedFrame} onSelect={setSelectedFrame} />
            <ColorSwatches selected={selectedCover} onSelect={setSelectedCover} />

            <div className={styles.summary}>
              <h3 className={styles.summaryTitle}>Tu Selección</h3>
              <p className={styles.summaryDetails}>
                Marco {selectedFrame === 'black' ? 'Negro' : 'Transparente'} + Cubierta {coverNames[selectedCover]}
              </p>
              <span className={styles.price}>
                {totalPrice.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
              </span>
              <Button size="lg" onClick={handleAddToCart}>
                Añadir al carrito
              </Button>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>
  )
}
